export default {
  independentMarketing: {
    common: {
      requestFailed: 'Mancata richiesta di interfaccia',
      hintSelect: 'accedere',
      hintInput: 'Inserisci',
      submit: 'Invia',
      cancel: 'Annulla',
      confirm: 'OK',
    },
    agreement: {
      title: 'Contratto di registrazione del rivenditore indipendente Autel',
      nextBtn: 'Prossimo',
      getAgreementFailed: 'Impossibile ottenere il contenuto del contratto.',
    },
    successPage: {
      title:
        'Le informazioni sulla tua richiesta sono state inviate con successo e i risultati della revisione verranno inviati al tuo indirizzo email $1 entro 15 giorni lavorativi. Controlla la tua casella di posta per ulteriori informazioni.',
      subTitle: 'Ritorna alla home page dopo $ 1 secondo/i.',
    },
    applyTitle:
      'Ti candidi per diventare rivenditore indipendente Autel. Si prega di compilare accuratamente le seguenti informazioni:',
    companyName: 'Nome società',
    companyTax: 'VAT ID',
    userCountry: 'Paese',
    legalPerson: 'Consulente legale',
    contactEmail: 'Contatto email',
    contactEmailTips:
      "Questo indirizzo email sarà il tuo contatto per l'email con il risultato della revisione. Una volta approvata la revisione, verrà utilizzato anche come nome dell'account di accesso per il sistema di gestione del rivenditore indipendente.",
    corporateIdentity: 'ID del consulente legale',
    uploadTips: 'JPG, JPEG, PNG, PDF (non più grande di 20 MB)',
    businessLicense: "Licenza d'affari",
    emailErrorTips: 'Inserire un indirizzo email valido.',
    uploadPic: 'Carica immagini',
    picMaxLimit: "La dimensione massima dell'immagine è 20 MB. Seleziona di nuovo.",
  },
};
